module.exports = __webpack_public_path__ + "assets/img/ddm_culture.c46c6063.jpg";